<template>
    <app-overlay-loader v-if="preloader"/>
    <form v-else ref="form" data-url="/sms-settings"
          class="mb-0"
          :class="{'loading-opacity': preloader}">

        <div class="form-group row align-items-center">
            <label class="col-lg-3 col-xl-3 mb-lg-0">
                {{ $t('test_number') }}
            </label>
            <div class="col-lg-8 col-xl-8">
                <app-input type="tel-input"
                           v-model="formData.test_number"
                           :placeholder="$t('test_number')"/>
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label for="smsSettingsSmsDriver" class="col-lg-3 col-xl-3 mb-lg-0">
                {{ $t('sms_driver') }}
            </label>
            <div class="col-lg-8 col-xl-8">
                <app-input id="smsSettingsSmsDriver"
                           type="select"
                           v-model="formData.sms_driver"
                           :required="true"
                           :list="driverList"/>
            </div>
        </div>

        <!--For Nexmo driver-->
        <fieldset v-if="formData.sms_driver === 'twilio'">
            <div class="form-group row align-items-center">
                <label for="smsSettingsKey" class="col-lg-3 col-xl-3 mb-lg-0">
                    {{ $t('account_sid') }}
                </label>
                <div class="col-lg-8 col-xl-8">
                    <app-input id="smsSettingsKey"
                               type="text"
                               v-model="formData.account_sid"
                               :placeholder="$t('account_sid')"
                               :required="true"/>
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label for="smsSettingsSecretKey" class="col-lg-3 col-xl-3 mb-lg-0">
                    {{ $t('auth_token') }}
                </label>
                <div class="col-lg-8 col-xl-8">
                    <app-input id="smsSettingsSecretKey"
                               type="text"
                               v-model="formData.auth_token"
                               :placeholder="$t('auth_token')"
                               :required="true"/>
                </div>
            </div>
            <div class="form-group row align-items-center">
                <label class="col-lg-3 col-xl-3 mb-lg-0">
                    {{ $t('twilio_number') }}
                </label>
                <div class="col-lg-8 col-xl-8">
                    <app-input type="tel-input"
                               v-model="formData.twilio_number"
                               :placeholder="$t('twilio_number')"
                               :required="true"/>
                </div>
            </div>
            <div class="form-group row align-items-center">
                <div class="col-lg-8 col-xl-8 offset-xl-3">
                    <app-input type="single-checkbox"
                               v-model="formData.send_auto_sms"
                               :list-value-field="$t('send_auto_sms')"
                               />
                </div>
            </div>

        </fieldset>

        <div class="mt-5 action-buttons">
            <button class="btn btn-primary mr-2" @click.prevent="submit">
                {{ $t('save') }}
            </button>
        </div>
    </form>
</template>

<script>
import {FormMixin} from "../../../../core/mixins/form/FormMixin";
import * as actions from "../../../Config/ApiUrl";

export default {

    name: "SmsSetting",
    mixins: [FormMixin],
    data() {
        return {
            preloader: false,
            formData: {
                sms_driver: 'twilio',
                account_sid: '',
                auth_token: '',
                twilio_number: '',
            },
            driverList: [
                {id: 'twilio', value: "Twilio"},
            ],
            showError: false,
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        beforeSubmit() {
            this.preloader = true;
        },
        submit() {
            this.save(this.formData);
        },
        afterFinalResponse() {
            this.preloader = false;
        },
        afterSuccess(res) {
            this.$toastr.s(res.data.message);
            window.location.reload();
        },
        afterError(res) {
            this.showError = true;
            this.$toastr.e(res.data.message);
        },
        getData() {
            this.preloader = true;
            let url = actions.GET_SMS_SETTINGS_INFO;
            this.axiosGet(url).then(response => {
                if (response.data.sms_driver) {
                    this.formData = response.data;
                } else {
                    this.formData = {
                        sms_driver: 'twilio',
                        account_sid: '',
                        auth_token: '',
                        twilio_number: '',
                    };
                }
            }).catch(({response}) => {

            }).finally(() => {
                this.preloader = false;
            });
        }
    }
}
</script>
